module.exports = __webpack_public_path__ + "static/media/noun-two-hearts-1927945-FFFFFF.a7bebd8a.svg";